import React from 'react';
import { Box, Container, Grid, Typography, Button, Stack, Divider } from '@mui/material';
import { FaPhoneAlt, FaTelegramPlane, FaArrowRight } from 'react-icons/fa';
import tikerSale from '../assets/images/tiket-sale.png';

const DiscountSection = () => {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        background: `
          radial-gradient(circle at 84% 24%, rgba(201,161,74,0.12) 0%, transparent 22%),
          radial-gradient(circle at 14% 78%, rgba(20,36,95,0.08) 0%, transparent 26%),
          linear-gradient(180deg, #f3f3f1 0%, #ebebe8 100%)
        `,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* Левая колонка – картинка с закруглёнными краями */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box
              component="img"
              src={tikerSale}
              alt="Скидка 20%"
              sx={{
                width: '100%',
                maxWidth: { xs: 200, md: '90%' },
                height: 'auto',
                display: 'block',
                margin: '0 auto',
                borderRadius: 4, // ← СКРУГЛЯЕМ КРАЯ
                filter: 'drop-shadow(0 12px 24px rgba(20,36,95,0.08))',
              }}
            />
          </Grid>

          {/* Правая колонка – информация */}
          <Grid size={{ xs: 12, md: 8 }}>
            <Box
              sx={{
                bgcolor: 'rgba(255,255,255,0.88)',
                borderRadius: 4, // ← такой же радиус, как у картинки
                p: { xs: 3, md: 4 },
                border: '1px solid rgba(20,36,95,0.08)',
                boxShadow:
                  '0 16px 38px rgba(0,0,0,0.08), 0 6px 18px rgba(20,36,95,0.05)',
                backdropFilter: 'blur(8px)',
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontFamily: '"Playfair Display", serif',
                  color: '#14245f',
                  fontWeight: 700,
                  fontSize: { xs: '1.8rem', md: '2.2rem' },
                  mb: 1,
                }}
              >
                ПОЛУЧИТЕ СКИДКУ 20%
              </Typography>

              <Typography
                sx={{
                  color: '#667085',
                  mb: 2,
                  fontSize: { xs: 14.5, md: 16 },
                  lineHeight: 1.75,
                }}
              >
                Акция действует на любую услугу при записи на сайте для новых
                клиентов, кроме окрашивания волос.
              </Typography>

              <Divider sx={{ borderColor: 'rgba(20,36,95,0.08)', mb: 2 }} />

              <Typography sx={{ color: '#4b556f', fontWeight: 600, mb: 1 }}>
                Записаться можно:
              </Typography>

              <Stack spacing={2} sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <FaPhoneAlt size={18} color="#b2872f" />
                  <Typography sx={{ color: '#14245f', fontWeight: 700 }}>
                    +7 (917) 030-03-08
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <FaTelegramPlane size={18} color="#b2872f" />
                  <Button
                    component="a"
                    href="https://t.me/lindos_beauty"
                    target="_blank"
                    sx={{
                      textTransform: 'none',
                      fontWeight: 600,
                      color: '#14245f',
                      p: 0,
                      '&:hover': { color: '#b2872f' },
                    }}
                  >
                    @lindos_beauty
                  </Button>
                </Box>
              </Stack>

              <Button
                variant="contained"
                fullWidth
                endIcon={<FaArrowRight />}
                onClick={() =>
                  window.open(
                    'https://n893698.yclients.com/company/833095/personal/menu?o=',
                    '_blank'
                  )
                }
                sx={{
                  py: 1.6,
                  borderRadius: 999,
                  textTransform: 'none',
                  fontSize: 16,
                  fontWeight: 700,
                  color: '#fff',
                  background:
                    'linear-gradient(135deg, #14245f 0%, #1a237e 58%, #2b3ea7 100%)',
                  boxShadow: '0 14px 28px rgba(26,35,126,0.24)',
                  '&:hover': {
                    background:
                      'linear-gradient(135deg, #101d4d 0%, #162067 58%, #22358f 100%)',
                  },
                }}
              >
                Записаться онлайн (YCLIENTS)
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default DiscountSection;